module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "CpImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：400*240"
    },
    model: {
      value: (_vm.formData.CpImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpImg", $$v)
      },
      expression: "formData.CpImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "CpName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CpName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpName", $$v)
      },
      expression: "formData.CpName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "CpDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.CpDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpDescribe", $$v)
      },
      expression: "formData.CpDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "CpSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CpSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpSort", _vm._n($$v))
      },
      expression: "formData.CpSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "CpContent"
    }
  }, [_c('mc-editor', {
    ref: "editContent",
    model: {
      value: (_vm.formData.CpContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpContent", $$v)
      },
      expression: "formData.CpContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-12baa785","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/other/CooperativeForm.vue
// module id = 729
// module chunks = 1